import React, { useEffect, useState } from 'react';
import { Modal, Select, DatePicker } from 'antd';
//*import NewEventRightCenter from '../../../components/chat/rightsidebar/neweventcenter';

import styles from "../../../components/chat/leftsidebar/scss/createdropdown.module.scss";
import { URButton } from '../../widgets/button';
//*import CreateTaskCenter from '../../../components/contacts/rightsidebar/taskcreatecenter';
import { useSelector } from 'react-redux';
import { userStatusColor } from '../../../base/callService/common';
import { contactService } from '../../../base/contactService';
//*import { chatSideWindow } from '../../../base/eventService/eventApiService';
import { getcontactDetail, SearchFilter } from '../../../base/utils';
import store from '../../../context/store/store';
import { initialStateModel,
  LoginState,contacts } from '../../../models/model';
import { URStatusDot } from '../../widgets/avatarGroup/statusDot';
import { URInput } from '../../widgets/input';
import taskimg2 from "../../../styles/images/task2.svg";
import { URAvatarGroup } from '../../widgets/avatarGroup';

type TaskPageState ={
  taskName:string,
  description:string,
  nameError:boolean,
  assigneeError:boolean,
  dueDate:any,
  dueError:boolean,
  assigneeArray:any,
  key:any
}


type createTaskProps = {
    open:boolean;
    openTask: (status:boolean)=>void;
}

export default function Createtask({open,openTask}:createTaskProps) {

  const [isModalVisible, setModalVisible] = useState(false);
console.log(open,"open")


  const handleCancel = ()=>{
    setModalVisible(false);
    openTask(false);
    setcreateTask({...createTask,taskName:"",description:"",nameError:false, assigneeError:false,dueError:false});
  };

  //*let isContact= window.location.pathname=== "/contacts"?true:false;
  /*let { contactWindowDetails}:contactwindowDetails =
  useSelector((state: initialStateModel) =>state.contactWindowReducer);*/
  // const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  // const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  // const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  //*let {chatWindowDetails ,isMySpace}=chatWindow;
  //*let {userdetails}= loginDetails;
  //*let {xmppDetails}= chatReducer;
  let {workContacts} :contacts =useSelector((state: initialStateModel) =>state.contactReducer);
  const [createTask, setcreateTask] = useState<TaskPageState>({ taskName:"",description:"",key:"login",
    nameError:false,assigneeError:false, dueDate:"", dueError:false,assigneeArray:[]});
  const [selectMember, setselectMember] = useState({
    contactList: workContacts, searchContactList: workContacts,contactDetail:[],
    selectedmember:[]
  });

  const disabledDate = (from: any, current: any) => {
    return new Date(from.setDate(from.getDate() - 1)) >= current;
  };

  useEffect(() => {
  
    setselectMember({...selectMember,
      contactList: workContacts, searchContactList: workContacts
    });
  }, [workContacts]);

  const onSaveTask=()=>{

    if((createTask.taskName.trim() === "" && selectMember.selectedmember.length < 1 && createTask.dueDate === "")){
      setcreateTask({...createTask,nameError:true, assigneeError:true, dueError:true});
    }else if(createTask.taskName.trim() === ""){
      setcreateTask({...createTask,nameError:true});
    }else if(selectMember.selectedmember.length < 1){
      setcreateTask({...createTask, assigneeError:true});
    }
    
    else if(!createTask.dueDate){
      setcreateTask({...createTask,dueError:true});
    }
    else
    {
      let assigneeArray:any= [];
      selectMember?.contactDetail.map((list:any)=>(
        assigneeArray.push(list.jid)
      ));
    
      contactService.createContactTask(createTask);
      setcreateTask({...createTask, taskName:"",description:"",nameError:false, 
      assigneeError:false,assigneeArray:[],dueDate:"",dueError:false});
      setselectMember({
        ...selectMember, selectedmember: []
      });
      setModalVisible(false);
      openTask(false);
      console.log(isModalVisible,"isModalVisible");
    }
    
  };

  const handleDate=(date:any,dateString:any)=>{

    if(date){
      setcreateTask({...createTask, dueDate:date,dueError:false});
    }else{
      setcreateTask({...createTask, dueDate:"",dueError:true});
    }
    
  };

  // const  onCancel=()=>{
  //   setcreateTask({...createTask,taskName:"",description:"",nameError:false, assigneeError:false});
   
  // };

  const handleChange=(e:any)=>{
    if(e.target.name === 'taskName'){
      setcreateTask({...createTask,nameError:false, [e.target.name]: e.target.value});
    }
    else{
      setcreateTask({...createTask,[e.target.name]: e.target.value});
    }
  };

  const onChangeSelectMembers =(e:any)=>{
    let {userdetails}:LoginState = store.getState().loginReducer;
    let contact:any=
    e.map((item:string)=>
    {
      return getcontactDetail(item.toString(),selectMember.contactList,userdetails);
    });
    setselectMember({
      ...selectMember, selectedmember: e,
      searchContactList: selectMember.contactList,contactDetail:contact
    });
    setcreateTask({...createTask, assigneeError:false,assigneeArray:e});
  };


  const onSearchMembers = (value: any) => {
    let response = SearchFilter(selectMember.contactList, value.toLowerCase());
    setselectMember({ ...selectMember, searchContactList: response });
  
  };
 
  let len = Math.ceil((selectMember?.searchContactList?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  return (
    <>
      <Modal visible={open} className={`${styles.newmessage} ${"modaloverwrite"} ${"taskcreation"} `}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={handleCancel}/>
        <h2>New Task  <span className="icon_ticknote"></span></h2>
        <div className={styles.rightsidebar}>
          <div className={styles.middlelayers}>
            <label>Task Name</label>
            <URInput placeHolder="Name the Task" name="taskName"
              className={createTask.nameError?`hoverbdrBlue ${styles.inputerror} ${styles.normalinput}`:`hoverbdrBlue ${styles.normalinput}`} value={createTask.taskName} onChange={handleChange}/>
            {createTask.nameError && <span className="error">Task due date required</span>}
            <label>Assigned To</label>
            <div className={styles.insideicon}>
              <img src={taskimg2} alt="" />
              <Select
                mode="multiple"
                onChange={(e: any) => onChangeSelectMembers(e)}
                onSearch={onSearchMembers}
                style={{ width: '100%' }}
                filterOption={false}
                showSearch={true}
                value={selectMember.selectedmember}
                placeholder="Select Employee"
                dropdownClassName="newChatSel"
                className={  createTask.assigneeError ?`inputerror newselects taskcreations`:"newselects taskcreations"}>
                { selectMember?.searchContactList?.map((contact:any,index:any)=>{
               
                  let name= contact?.caller_id ?contact?.caller_id : contact?.team_name;
                  return(
             
                    <option key={index}
                      value={contact.sip_login_id?contact.sip_login_id: `con${contact.team_id}`}>
                      <div className="dropdowndesign">
                        <div className="usergroupss">
                        <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                                  {contact.ImageURL || contact.profile_image_url ?
                                  <img alt="" src={contact.ImageURL?contact.ImageURL:contact.profile_image_url} className={styles.imgSelected}/> :
                                    <span>{name?.charAt(0).toUpperCase()}</span>}
                                  <URStatusDot
                                    className={userStatusColor(contact?.user_status,'small')}/>
                                </> } />
                          {/* {contact.ImageURL || contact.profile_image_url?
                            <img src={contact.ImageURL?contact.ImageURL:contact.profile_image_url}/>:
                            <span>{name?.charAt(0)}</span>
                          } */}
                          {/* <URStatusDot className={userStatusColor(contact?.user_status,'small')}/> */}
                        </div>
                        <div className="names">{name && name}</div>
                        {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                      </div>
                    </option>
              
                  );

            
                })  }
         
              </Select>
            </div>
            {createTask.assigneeError && <span className="error">Assign task to Someone</span>}
            <label>Due Date</label>
            <div className={styles.insideicon}>
              <DatePicker className={createTask.dueError?"hoverbdrBlue inputerror customDatepicker":"hoverbdrBlue customDatepicker"}
                disabledDate={(e) => disabledDate(new Date(), e)}
                value={createTask.dueDate}
                onChange={(date: any, dateString: any)=>handleDate(date, dateString)} format="DD/MM/YYYY"
                dropdownClassName='datepickerDropdown' placeholder='Due date' /></div>
            {createTask.dueError && <span className="error">Due Date is Required</span>}
            <label>Description</label>
            <textarea name="description" onChange={handleChange}
              value={createTask.description} className="hoverbdrBlue" placeholder="Write a task description"></textarea>
          </div>
        </div>
        <div className={`${styles.footersection} ${"footersection"} padlrzero `}>
          <URButton className="urButton buttonWhite " name="Cancel" onClick={handleCancel}></URButton>
          <URButton className="urButton buttonBlue marlftmin" onClick={onSaveTask} name="Save"></URButton>
        </div>
      </Modal>
    </>
  );
}
